import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RisReqDto } from '../_dtos/risReqDto';
import { RisOrderResDto } from '../_dtos/risOrderResDto';
import { SkipLoading } from '../_interceptors/loading.interceptor';
import { RisProjectTypeResDto } from '../_dtos/risProjectTypeResDto';

@Injectable({
  providedIn: 'root',
})
export class RisService {
  private orderURI =
    environment.risBaseUrl + '/projects?code=' + environment.risKey;
  private projectTypeURI = `${environment.risBaseUrl}/projecttypes?code=${environment.risKey}`;

  private readonly skipLoaderContext;

  constructor(private http: HttpClient) {
    this.skipLoaderContext = new HttpContext().set(SkipLoading, true);
  }

  orderRis(risData: RisReqDto): Observable<RisOrderResDto> {
    return this.http.post<RisOrderResDto>(this.orderURI, risData, {
      context: this.skipLoaderContext,
    });
  }

  getProjectTypes(): Observable<RisProjectTypeResDto[]> {
    return this.http.get<RisProjectTypeResDto[]>(this.projectTypeURI);
  }
}
